import store from '../'

export function onRobots (robots) {
  store.commit('updateRobots', robots)
}



// WEBPACK FOOTER //
// ./src/store/actions/robots.js